/**
 * Clase que contabiliza las estadísticas mediante GTM
 *
 * El parámetro args.dataLayer recibe el objeto contenedor
 * de todas las llamadas.
 *
 * El parámetro lang recibe el idioma de la página
 *
 * El parámetro device recibe el tipo de dispositivo desde el
 * que se está visualizando, que puede ser desktop, mobile o
 * tablet.
 */

function Statistics(args)
{
    /**
     * Tamaño de la galería de vídeos más porpulares, los que se
     * encuentren en estas primeras posiciones irán a esa galería,
     * el resto a la galería secundaria de los vídeos más votados.
     *
     * En aquellos sitios en las que su página de inicio se divida
     * en dos galerías (como pichaloca o serviporno), se deberá
     * establecer en el constructor el tamaño de la primera de ellas.
     *
     * En caso contrario, para los sitios cuya página de inicio no
     * se divida en galerías (como pornburst o las versiones móvil)
     * automáticamente toma el valor 0 por defecto.
     */
    this.mostPopularListLength = 0;

    /**
     * Tamaño de la galería de vídeos relacionados. Por defecto su
     * valor será 12, aunque esto puede modificarse al construir el
     * objeto.
     */

    this.relatedListLength = 12;

    /**
     * Indica si la red tiene un sufijo numérico para el idioma,
     * como es el caso de PornBurst. Por defecto su valor será vacío.
     *
     * @type {string}
     */
    this.suffix = '';

    /**
     * Indica la orientación por defecto de todos los vídeos
     * de una red. Su valor por defecto será nulo, de manera
     * que a priori no se establece ninguna orientación por
     * defecto y será en el constructor de las estadísticas
     * de la red donde se podrá especificar.
     *
     * Se utiliza fundamentalmente en la red PichaLoca, ya que
     * tiene una orientación exclusiva.
     *
     * @type {string}
     */
    this.defaultNetworkProfile = null;

    this.categories = [];
    this.categoriesMapped = [];

    if(args !== undefined)
    {
        this.siteName = args.siteName;
        this.siteDomain = args.siteDomain;
        this.siteProject = args.siteProject;
        this.siteNetwork = args.siteNetwork;
        this.dataLayer = args.dataLayer;
        this.lang = args.lang;
        this.device = args.device;

        if(args.mostPopularListLength)
        {
            this.mostPopularListLength = args.mostPopularListLength;
        }

        if(args.relatedListLength)
        {
            this.relatedListLength = args.relatedListLength;
        }

        if(args.suffix)
        {
            this.suffix = args.suffix;
        }

        if(args.defaultNetworkProfile)
        {
            this.defaultNetworkProfile = args.defaultNetworkProfile;
        }
    }

    // array de vídeos de galerías principales que se enviarán tras la carga de la página
    this.videos = [];

    // array de vídeos relacionados que se enviarán tras la carga de la página
    this.relatedVideos = []; // array de los vídeos

    /**
     * Llama a todos los métodos encargados de enviar
     * información a GTM dentro del header de la página.
     *
     * En función del parámetro se indica la template que
     * está mostrando las galerías, ya que la funcionalidad
     * varía de una a otra.
     *
     * @domains
     *
     *      Listado de los dominios del sitio.
     *
     */
    this.onLoadPageStatics = function(template, args, domains)
    {
        this.increaseVisit(args, domains);

        switch(template)
        {
            case(StatsUtil.LIST_VIDEOS):
                this.sendVideosData();

                break;

            case(StatsUtil.VIDEO_DETAIL):
                if(args.video != null && args.video != undefined)
                {
                    this.sendVideoDetailData(args.video);
                }

                this.sendRelatedVideosData(1, true, null, args.video);

                break;
        }
    };

    /**
     * Envía a GTM la primera galería de vídeos relacionados
     * al cargar la página de detalle de un vídeo, además de
     * información adicional sobre el propio vídeo principal.
     *
     * @param onLoad
     *
     *      Parámetro que indica si las galerías relacionadas
     *      se han de enviar al cargar la página o cuando el
     *      usuario solicita más vídeos relacionados pinchando
     *      en el botón.
     */
    this.sendRelatedVideosData = function(galleryNum, onLoad, statistics, video)
    {
        if(statistics == null || statistics == undefined)
        {
            statistics = this;
        }

        if(onLoad)
        {
            if(statistics.relatedVideos[galleryNum] instanceof Array)
            {
                statistics.dataLayer.push(
                {
                    'ecommerce':
                    {
                        'detail':
                        {
                            'actionField': '',
                            'products':
                            [{
                                'id': this.siteNetwork + '_' + this.lang + '_' + video.id,
                                'name': video['title' + this.lang.charAt(0).toUpperCase() + this.lang.slice(1) + this.suffix],
                                'category': '',
                                'dimension16': video.ratingEntity.totalVotes
                            }]
                        },
                        'impressions': this.relatedVideos[galleryNum]
                    }
                });
            }
        }
        else
        {
            statistics.dataLayer.push(
            {
                'event': 'videoData',
                'videoCategory': 'Similares',
                'ecommerce':
                {
                    'impressions': statistics.relatedVideos[galleryNum]
                }
            })
        }
    };

    /**
     * Envía a GTM la información de un vídeo cuando se entra
     * en el detalle del mismo
     */
    this.sendVideoDetailData = function(video)
    {
        this.dataLayer.push(
        {
            'videoTag': StatsUtil.printVideoCategories(video, this.lang, this.suffix),
            'pornStar': StatsUtil.printVideoPornstars(video),
            'videoName': video['title' + this.lang.charAt(0).toUpperCase() + this.lang.slice(1) + this.suffix]
        });
    };

    /**
     * Envía a GTM una búsqueda vacía cuando el usuario no
     * ha obtenido ningún resultado.
     */
    this.sendEmptySearch = function(search)
    {
        this.dataLayer.push(
        {
            'category': 'Interaction',
            'action': 'EmptySearch',
            'label': search,
            'event': 'eventga'
        });
    };

    /**
     * Envía a GTM la información requerida cuando la web
     * muestra la página de error.
     */
    this.sendErrorPageShown = function()
    {
        this.dataLayer.push(
        {
            'virtualUrl': '/error.html?page=' + document.location.pathname + document.location.search + '&from=' + document.referrer
        });
    };

    /**
     * Envía a GTM la información requerida cuando el usuario
     * comienza a reproducir un vídeo.
     */
    this.sendPlayVideo = function(video)
    {
        var videoName;

        if(video.name)
        {
            videoName = video.name;
        }
        else
        {
            videoName = video['title' + this.lang.charAt(0).toUpperCase() + this.lang.slice(1) + this.suffix];
        }

        this.dataLayer.push(
        {
            'event': 'ecommerce.js',
            'category': 'Video',
            'action': 'Play',
            'ecommerce':
            {
                'add':
                {
                    'products':
                    [{
                        'id': this.siteNetwork + '_' + this.lang + '_' + video.id,
                        'name': videoName,
                        'category': '',
                        'dimension16': video.ratingEntity.totalVotes
                    }]
                }
            }
        });
    };

    /**
     * Envía a GTM un evento indicando que se ha desplegado
     * la barra de búsqueda en la versión móvil.
     */
    this.sendMobileSearchOpen = function()
    {
        this.dataLayer.push(
        {
            'category': 'Interaction',
            'action': 'Show',
            'label': 'Search',
            'event': 'eventga'
        });
    };

    /**
     * Envía a GTM un evento indicando que se ha desplegado
     * el menú principal en la versión móvil.
     */
    this.sendMobileMenuOpen = function()
    {
        this.dataLayer.push(
        {
            'category': 'Interaction',
            'action': 'Show',
            'label': 'Menu',
            'event': 'eventga'
        });
    };

    /**
     * Añade los eventos necesarios a los elementos que se
     * muestran en el detalle de un vídeo para el envío de
     * estadísticas.
     *
     */
    this.addVideoDetailEvents = function()
    {
        this.addShowMoreButtonEvent();
        this.addVideoListEvents();
    };

    this.addShowMoreButtonEvent = function()
    {
        var statistics = this;

        $('#show-more, .action-show-more, .action-show-more-videos').on('click', function(ev)
        {
            if(statistics.device == 'desktop')
            {
                statistics.showMoreButtonDesktopEvent();
            }
            else
            {
                statistics.showMoreButtonMobileEvent();
            }
        });
    };

    this.showMoreButtonDesktopEvent = function()
    {
        var galleries = $('#related_videos>div');

        var numGalleries = galleries.length;

        for(var i = 0 ; i < numGalleries ; i++)
        {
            if($(galleries[i]).css('display') != 'none')
            {
                // determina si la galería a mostrar vuelve a ser la primera

                if(i == numGalleries - 1)
                {
                    statistics.sendRelatedVideosData(1, false, statistics);
                }
                else
                {
                    statistics.sendRelatedVideosData(i + 2, false, statistics);
                }

                break;
            }
        }
    };

    this.showMoreButtonMobileEvent = function()
    {
        var galleries = $('.listado-relacionados>div');

        if(galleries.length != 0)
        {
            this.sendCommonRelatedVideosData(galleries)
        }
        else
        {
            galleries = $('.box-relacionados');

            this.sendCPRelatedVideosData(galleries)
        }
    };

    /**
     * Envía a gtm los vídeos relacionados a la manera de CanalPorno.
     *
     * @param galleries
     */
    this.sendCPRelatedVideosData = function(galleries)
    {
        var numGalleries = galleries.length;

        for(var i = 0 ; i < numGalleries ; i++)
        {
            if($(galleries[i + 1]).parent().css('display') == 'none' || $(galleries[i]).parent().next('div').html() == '')
            {
                statistics.sendRelatedVideosData(i + 2, false, statistics);

                break;
            }
        }
    };

    /**
     * Envía a gtm los vídeos relacionados de la manera habitual.
     *
     * @param galleries
     */
    this.sendCommonRelatedVideosData = function(galleries)
    {
        var numGalleries = galleries.length;

        for(var i = 0 ; i < numGalleries ; i++)
        {
            if($(galleries[i + 1]).css('display') == 'none' || $(galleries[i + 1]).hasClass('clear') || $(galleries[i]).attr('data-last-gallery') == 'true')
            {
                statistics.sendRelatedVideosData(i + 1, false, statistics);

                break;
            }
        }
    };

    /**
     * Determina el perfil de un vídeo en función de sus
     * categorías, una vez que el usuario entra en el detalle
     * del mismo.
     */
    this.addVideoOrientation = function(categories)
    {
        var videoProfile = this.defaultNetworkProfile;

        if(videoProfile == null)
        {
            videoProfile = this.checkVideoOrientation(categories)
        }

        statistics.dataLayer.push(
        {
            'videoProfile': videoProfile
        });
    };

    this.checkVideoOrientation = function(categories)
    {
        var videoProfile = StatsUtil.VIDEO_PROFILE_HETERO;

        var gayCategories = StatsUtil.GAY_CATEGORIES[this.siteNetwork];
        var transCategories = StatsUtil.TRANS_CATEGORIES[this.siteNetwork];

        var numCategories = categories.length;

        for(var i = 0 ; i < numCategories && videoProfile == StatsUtil.VIDEO_PROFILE_HETERO ; i++)
        {
            var currentCategory = categories[i];

            if($.inArray(currentCategory, gayCategories) != -1)
            {
                videoProfile = StatsUtil.VIDEO_PROFILE_GAY;
            }
            else if($.inArray(currentCategory, transCategories) != -1)
            {
                videoProfile = StatsUtil.VIDEO_PROFILE_TRANS;
            }
        }

        return videoProfile;
    };

    /**
     * Añade los eventos necesarios a las previas de los
     * vídeos para el envío de estadísticas.
     */
    this.addVideoListEvents = function()
    {
        var statistics = this;

        $('.muestra-escena, .listado-escenas a.box-escena, .muestra-canal a, .box-escena a, .box-relacionados, .box-thumb').on('click', function(ev)
        {
            if(!$(this).attr('data-click-event-added')) // evita posible eventos duplicados dado que cada tube etiqueta de manera diferente
            {
                $(this).attr('data-click-event-added', true);

                var listName = $(this).data('stats-list-name');
                var positionInList = $(this).data('stats-list-pos');

                statistics.dataLayer.push(
                {
                    'event': 'ecommerce.js',
                    'ecommerce':
                    {
                        'click':
                        {
                            'actionField': {'list': listName},
                            'products': [
                            {
                                'id': statistics.siteNetwork + '_' + statistics.lang + '_' + $(this).data('stats-video-id'),
                                'name': $(this).data('stats-video-name'),
                                'category': $(this).data('stats-video-category'),
                                'position': positionInList
                            }]

                        }

                    }
                });
            }
        });
    };

    /**
     * Envía el array de la clase con la información de todos
     * los vídeos de la galería que se está mostrando a GTM.
     */
    this.sendVideosData = function(virtualPage)
    {
        var data = {
            'ecommerce': {
                    'impressions': this.videos
            }
        };

        if (virtualPage !== undefined) {
            data["virtualPage"] = virtualPage;
            data['event'] = 'paginationData';
        }

        dataLayer.push(data);
    }

    /**
     * Almacena en el array de la clase la información de uno
     * de los vídeos que se encuentran en la galería que se
     * está mostrando.
     */
    this.onLoadVideoStatics = function(video, pos, list, category)
    {
        var videoInfo =
        {
            'id': this.siteNetwork + '_' + this.lang + '_' + video.id,
            'name': video['title' + this.lang.charAt(0).toUpperCase() + this.lang.slice(1) + this.suffix],
            'list': list,
            'position': pos
        };

        if(category != null && category != undefined)
        {
            videoInfo.category = category;
        }

        this.videos.push(videoInfo);
    }

    /**
     * Almacena en el array de la clase la información de uno
     * de los vídeos que se encuentran en la galería que se
     * está mostrando.
     *
     * Este método sólo se aplica para la portada de la página,
     * ya que tiene una categorización especial de listados.
     */
    this.onLoadIndexVideoStatics = function(video, pos, list, category)
    {
        var data = {
            'id': this.siteNetwork + '_' + this.lang + '_' + video.id,
            'name': video['title' + this.lang.charAt(0).toUpperCase() + this.lang.slice(1) + this.suffix],
            'category': '',
            'list': StatsUtil.getVideoListName(pos, this.mostPopularListLength),
            'position': pos
        };

        if (list !== undefined) {
            data["list"] = list;
        }

        if (category !== undefined) {
            data["category"] = category;
        }

        this.videos.push( data );
    }

    /**
     * Almacena en el array de la clase la información de cada
     * uno de los vídeos que aparecen en las galerías de relacionados.
     *
     * Esta colección separa los vídeos relacionados en bloques, los
     * cuales se ocultan o muestran en la web cuando el usuario pincha
     * en el enlace para mostrar más.
     */
    this.onLoadVideoRelatedStatics = function(video, pos)
    {
        var galleryNumber = (Math.floor((pos - 1) / this.relatedListLength)) + 1;

        // Si la galería correspondiente al vídeo no existe en el listado de vídeos relacionados, se crea

        if(!this.relatedVideos[galleryNumber])
        {
            this.relatedVideos[galleryNumber] = [];
        }

        this.relatedVideos[galleryNumber].push(
        {
            'id': this.siteNetwork + '_' + this.lang + '_' + video.id,
            'name': video['title' + this.lang.charAt(0).toUpperCase() + this.lang.slice(1) + this.suffix],
            'category': '',
            'list': 'Similares',
            'position': pos - ((galleryNumber - 1) * this.relatedListLength)
        });
    }

    /**
     * Incrementa la visita al cargar una página.
     */
    this.increaseVisit = function(args, domains)
    {
        var siteData =
        {
            'siteName': this.siteName,
            'siteMainDomain': this.siteDomain,
            'siteProject': this.siteProject,
            'siteNetwork': this.siteNetwork,
            'siteLang': this.lang,
            'siteTargetDevice': this.device,
            'siteLinkedDomains': domains
        };

        if(args.video)
        {
            siteData.videoCategory = '';
            siteData.pornStar = StatsUtil.printVideoPornstars(args.video);
        }
        else
        {
            if(args.videoCategory)
            {
                siteData.videoCategory = args.videoCategory;
            }

            if(args.pornStar)
            {
                siteData.pornStar = args.pornStar;
            }
        }

        this.dataLayer.push(siteData);
    }

    this.sendCdnInfo = function(url) {
        var domain = url.replace(new RegExp('(https?:)?//([^/]+)/.*'), '$2');
        var cdn = 'Unknown';

        switch (domain.replace(/cdn([a-z]+)\d+[a-z]*\..*/, '$1')) {
            case 'mlw':
                cdn = 'LeaseWeb MultiCdn';
                break;
            case 'lw':
                cdn = 'LeaseWeb';
                break;
            case 'ip':
                cdn = 'Beluga';
                break;
            case 'lt':
                cdn = 'Level3';
                break;
            case 'ec':
                cdn = 'Edgecast';
        }

        this.dataLayer.push({
            'cdn': cdn,
            'cdnZone': domain
        });
    };

    this.addTimeTracker = function(playerId) {
        var dataLayer = this.dataLayer;
        var video = document.getElementById(playerId);

        if (!video) {
            // TODO: With VideoJS we could implement a plugin for the time tracking.
            return;
        }

        var addEvent = function(evnt, elem, func) {
            if (elem.addEventListener)  // W3C DOM
                elem.addEventListener(evnt, func, false);
            else if (elem.attachEvent) { // IE DOM
                elem.attachEvent("on" + evnt, func);
            }
        };

        var removeEvent = function(evnt, elem, func) {
            if (elem.removeEventListener)  // W3C DOM
                elem.removeEventListener(evnt, func, false);
            else if (elem.detachEvent) { // IE DOM
                elem.detachEvent("on" + evnt, func);
            }
        };

        var getCurrentTime = Date.now || function() {
                return +new Date;
            };

        var startTrackingTime = function() {
            time = getCurrentTime();
        };

        var finishTrackingWaitingTime = function() {
            var finalTime = getCurrentTime() - time;

            dataLayer.push({
                'event': 'timing',
                'timingCategory': 'Video',
                'timingVar': 'Waiting play',
                'timingValue': finalTime.toString()
            });

            removeEvent('play', video, startTrackingTime);
            removeEvent('playing', video, finishTrackingWaitingTime);

            addEvent('seeking', video, startTrackingSeekTime);
            addEvent('playing', video, abortTrackingSeekTime);
        };

        var startTrackingSeekTime = function() {
            time = getCurrentTime();

            addEvent('seeked', video, finishTrackingSeekTime);
        };

        var abortTrackingSeekTime = function() {
            removeEvent('seeked', video, finishTrackingSeekTime);
        };

        var finishTrackingSeekTime = function() {
            var finalTime = getCurrentTime() - time;

            dataLayer.push({
                'event': 'timing',
                'timingCategory': 'Video',
                'timingVar': 'Waiting Seek',
                'timingValue': finalTime.toString()
            });

            removeEvent('seeked', video, finishTrackingSeekTime);
        };

        var time = getCurrentTime();

        addEvent('play', video, startTrackingTime);
        addEvent('playing', video, finishTrackingWaitingTime);
    }

    /**
     * Envía a GTM la información de un vídeo cuando se entra
     * en el detalle del mismo
     */
    this.addCategoryHomeData = function(category, list) {
        this.categories.push({
            'id': category.id,              // "big_ass" es el valor de la categoría
            'name' : category.name,         // "Big Ass" es el valor de la categoría en inglés
            'category': category.category,
            'brand': category.brand,
            'dimension34': category.thumb,  //Nombre del JPG de thumb categoría
            'list': list,                   //Por ser listado de la home page. Para la lista de categorías deberá utilizarse 'Category - List'
            'position': category.position   //Posición de la categoría en el listado (número)
        });
    };

    /**
     * Envía a GTM la información de las categorías de la home
     */
    this.sendCategoriesHomeData = function() {

        var data = {
            'ecommerce': {
                'impressions': this.categories
            }
        };

        dataLayer.push(data);
    };

    /**
     * Envía a GTM la información del click en una categoría
     */
    this.bindCategoryClickEvent = function(list, category, link_class)
    {
        $('.' + link_class).on('click', function(ev) {
            var data = {
                'event':  'ecommerce.js',
                'ecommerce': {
                    'click': {
                        'actionField':  {'list': list},
                        'products': [{
                            'id': category.id,
                            'name' : category.name,
                            'category': category.category,
                            'brand': category.brand,
                            'dimension34': category.thumb,
                            'list': list,
                            'position': category.position
                        }]
                    }
                }
            };
            dataLayer.push(data);
        });
    };

    this.sendVirtualPageEvent = function(eventName, virtualPage) {

        var data = {
            'ecommerce': {
            }
        };

        if (virtualPage !== undefined) {
            data["virtualPage"] = virtualPage;
        }

        if (typeof eventName != 'undefined') {
            data.event = eventName;
        }

        dataLayer.push(data)
    };
}
